import {
	Component,
	OnInit,
	OnDestroy,
	ContentChild,
	TemplateRef,
	Input
} from '@angular/core';
import { DropdownService } from '@edassist-ui/dropdown';
import { DropdownComponent } from '@edassist-ui/dropdown/dropdown.component';
import { constants } from '@edassist/common';

@Component({
	selector: 'ea-dropdown-nav-item',
	templateUrl: './dropdown-nav-item.component.html',
	styleUrls: ['./dropdown-nav-item.component.scss']
})
export class DropdownNavItemComponent
	extends DropdownComponent
	implements OnInit, OnDestroy
{
	@Input() iconName: string;
	@Input() tooltipText?: string;
	@Input() faIconClass?: string;

	constructor(readonly dropdownService: DropdownService) {
		super(dropdownService);
	}

	ngOnInit(): void {
		super.ngOnInit();
	}

	toggleDropDown(): void {
		this.dropdownService.close(constants.dropdownIds.profileActions);
		this.dropdownService.close(constants.dropdownIds.otherServices);
		this.dropdownService.close(constants.dropdownIds.supportServices);
		super.toggleDropDown();
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}
}
